import { derived } from 'svelte/store';
import { createFeed, createFilteredFeed } from '../stores.js';
import { findElementInShadowDom } from './render.js';
import { findAndRenderRaceResultElements } from './embed-render-two-col-table.js';

/**
 * Finds a legislature race table embed container and mounts it.
 *
 * `embedName` must match the `data-embed-name` attribute on the
 * `.summary-results-container` div rendered by two_col_table_template.html,
 * which is set from `unique_identifier` in the embed data (e.g. 'california-us-house').
 *
 * @param {string} embedName - Value of data-embed-name on the container div
 * @param {string} feedUrl - URL to poll for race data
 * @param {string} office - Office type to filter by
 * @param {string[]} [excludeIds] - Race IDs to exclude
 */
export async function mountLegislature(
  embedName,
  feedUrl,
  office,
  excludeIds = []
) {
  const container = findElementInShadowDom(
    `.summary-results-container[data-embed-name='${embedName}']`
  );
  if (!container) return;
  const feed = await createFeed(feedUrl);
  const officeFeed = createFilteredFeed(feed, {
    offices: [office],
    sort: 'seat',
  });
  const filteredFeed = excludeIds.length
    ? derived(officeFeed, ($feed) =>
        $feed.filter((r) => !excludeIds.includes(r.id))
      )
    : officeFeed;
  findAndRenderRaceResultElements(container, filteredFeed);
}
